import React from 'react';
import {
  Button,
  Copy,
  Flex,
  Heading,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';
import { Modal } from 'src/components/Modal/Modal';

export type ConfirmPlusFeatureCancellationProps = {
  onConfirm: (value: boolean) => void;
  onClose: () => void;
  plusBrandName: string;
};

export function ConfirmPlusFeatureCancellation({
  plusBrandName,
  onConfirm,
  onClose,
}: ConfirmPlusFeatureCancellationProps): JSX.Element {
  return (
    <Modal size="sm">
      <Square as="header" dimension="2" width="100%">
        <Square inset="md">
          <Heading variant="h1">{`Cancel ${plusBrandName} membership?`}</Heading>
        </Square>
      </Square>
      <Square inset="md">
        <Copy variant="body">
          This will remove all membership benefits for this client.
        </Copy>
      </Square>
      <Square as="footer" dimension="2" inset="md">
        <Flex>
          <Stack x="x-sm" data-testid="add-button-wrapper">
            <Button variant="secondary" buttonSize="medium" onClick={onClose}>
              Never mind
            </Button>
          </Stack>
          <Button
            variant="primary"
            buttonSize="medium"
            onClick={(): void => {
              onConfirm(false);
            }}
          >
            Got it
          </Button>
        </Flex>
      </Square>
    </Modal>
  );
}
